import { DataSource } from '@angular/cdk/table';

export abstract class ElDataSource<T> extends DataSource<T> {}
